var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('form-table-row', {
    attrs: {
      "label": "참조품번",
      "cols": "4",
      "lg": "6"
    }
  }, [_c('v-text-field', _vm._b({
    model: {
      value: _vm.form.MODEL_CODE,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "MODEL_CODE", $$v);
      },
      expression: "form.MODEL_CODE"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs), false))], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "d-block d-lg-none"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('form-table-row', {
    attrs: {
      "label": "참조품명",
      "cols": "4",
      "lg": "6"
    }
  }, [_c('v-text-field', _vm._b({
    model: {
      value: _vm.form.MODEL_NAME,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "MODEL_NAME", $$v);
      },
      expression: "form.MODEL_NAME"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs), false))], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "d-none d-xl-block",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "d-block d-xl-none"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('form-table-row', {
    attrs: {
      "label": "참조Rev.",
      "cols": "4",
      "lg": "6"
    }
  }, [_c('v-text-field', _vm._b({
    model: {
      value: _vm.form.REVISION,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "REVISION", $$v);
      },
      expression: "form.REVISION"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs), false))], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "d-none d-xl-block",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "d-block d-xl-none"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('form-table-row', {
    attrs: {
      "label": "참조Rank",
      "cols": "4",
      "lg": "6"
    }
  }, [_c('v-text-field', _vm._b({
    model: {
      value: _vm.form.RANK,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "RANK", $$v);
      },
      expression: "form.RANK"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs), false))], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }